import { PlayerFrame, captureFrame } from 'components/app/app-components/frame-generator/frame-generator.helper';

interface Props {
  url: string;
  cb: (data: PlayerFrame) => void;
}

export const FrameGeneratorImage = ({ url, cb }: Props) => {
  return (
    <img
      crossOrigin="anonymous"
      onLoad={(e) => cb(captureFrame(e.currentTarget, e.currentTarget.naturalWidth, e.currentTarget.naturalHeight))}
      src={url}
    />
  );
};
